<template>
  <div class="table-actions d-flex justify-content-end">
    <slot />
    <b-button
      v-if="view_show"
      :to="view_to_converted"
      :variant="view_variant"
      @click="$emit('show', item)"
      >{{ view_text }}</b-button
    >
    <b-button
      v-if="view_edit"
      :to="edit_to_converted"
      :variant="edit_variant"
      @click="$emit('edit', item)"
      ><font-awesome-icon :icon="edit_icon"
    /></b-button>
    <b-button
      @click="delete_item(item)"
      v-if="view_delete"
      variant="outline-danger"
    >
      <font-awesome-icon :icon="delete_icon" />
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
    view_show: {
      default: true,
      type: Boolean,
    },
    view_edit: {
      default: true,
      type: Boolean,
    },
    view_delete: {
      default: true,
      type: Boolean,
    },
    view_text: {
      default: "Ver",
      type: String,
    },
    view_variant: {
      default: "info",
      type: String,
    },
    view_to: {
      type: String,
    },
    view_params: {
      type: Object,
      default: null,
    },

    edit_show: {
      default: true,
      type: Boolean,
    },
    edit_text: {
      default: "Editar",
      type: String,
    },
    edit_variant: {
      default: "outline-exitos",
      type: String,
    },
    edit_to: {
      type: String,
    },
    edit_params: {
      type: Object,
      default: null,
    },
    edit_icon: {
      type: String,
      default: "far fa-edit",
    },

    delete_show: {
      default: true,
      type: Boolean,
    },
    delete_icon: {
      type: String,
      default: "far fa-trash-alt",
    },
    delete_infors: {
      type: String,
      default: "",
    },
  },
  computed: {
    view_to_converted() {
      var params = this.view_params ? this.view_params : { id: this.item.id };

      return { name: this.view_to, params: params };
    },
    edit_to_converted() {
      var params = this.edit_params ? this.edit_params : this.item;
      return this.edit_to ? { name: this.edit_to, params: params } : null;
    },
  },
  methods: {
    delete_item(item) {
      const msn = this.delete_infors
        ? this.delete_infors
        : "Você tem certeza que deseja excluir?";

      this.$bvModal
        .msgBoxConfirm(msn, {
          okVariant: "danger",
          okTitle: "SIM",
          cancelVariant: "info",
          cancelTitle: "NÃO",
        })
        .then((value) => {
          if (value) {
            this.$emit("delete", item);
          }
        });
    },
  },
};
</script>
